module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Consoles_SE3HD.4146c6b0.png";